import React from "react";
import { Row, Col, Container } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import Button from "components/Button";
import {
    Secao,
    Titulo,
    Subtitulo,
    Coluna,
    Cartao,
    CartaoTitulo,
    CartaoTexto,
    Acoes,
    Passos,
    Nota
} from './styled';

// Página de quem chega pela TV (QR code da tela de entrada do app da TV, 03/10/2026).
// Em 14 dias, umas 10 casas por dia abriram o app na TV SEM ter conta e desistiram: a
// tela da TV só ensinava quem já é assinante. Aqui ficam os dois caminhos.
export default function ConectarTV(){
    const history = useHistory();

    const verPlanos = () => {
        const planos = document.getElementById('planos');
        if (planos) planos.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <Secao>
            <Container>
                <Titulo>Assista a JoinKids na sua TV</Titulo>
                <Subtitulo>Desenhos e vídeos infantis com segurança, na tela grande da sua casa.</Subtitulo>
                <Row>
                    <Col md={{ size: 6 }}>
                        <Coluna>
                            <Cartao>
                                <CartaoTitulo>Ainda não é assinante?</CartaoTitulo>
                                <CartaoTexto>
                                    Assine pelo celular em poucos minutos. Depois é só gerar o código no
                                    app da JoinKids e digitar na TV.
                                </CartaoTexto>
                                <CartaoTexto>
                                    Antes de assinar, você pode conhecer as categorias e os desenhos do nosso catálogo.
                                </CartaoTexto>
                                <Acoes>
                                    <Button primary onClick={verPlanos}>Ver os planos</Button>
                                    <Button secondary onClick={() => history.push('/conteudos')}>Conhecer o catálogo</Button>
                                </Acoes>
                            </Cartao>
                        </Coluna>
                    </Col>
                    <Col md={{ size: 6 }}>
                        <Coluna>
                            <Cartao>
                                <CartaoTitulo>Já é assinante? Conecte sua TV</CartaoTitulo>
                                <Passos>
                                    <li>
                                        Instale o app JoinKids na TV. Na Samsung (a partir de 2019), abra Apps
                                        e pesquise joinkids. Na LG (a partir de 2020), abra a LG Content Store
                                        e pesquise joinkids.
                                    </li>
                                    <li>
                                        No celular, abra o app JoinKids e toque em Perfil, depois em
                                        Acesso à TV e em Gerar código.
                                    </li>
                                    <li>
                                        Na TV, digite os 5 números e aperte Entrar. O código vale por 1 hora e só o
                                        mais novo funciona: se gerar outro, use o novo.
                                    </li>
                                </Passos>
                                <Nota>
                                    Ainda não tem o app no celular? Baixe na{' '}
                                    <a href="https://apps.apple.com/br/app/joinkids-brasil/id6443968852" target="_blank" rel="noopener noreferrer">App Store</a>
                                    {' '}ou no{' '}
                                    <a href="https://play.google.com/store/apps/details?id=com.joinkids" target="_blank" rel="noopener noreferrer">Google Play</a>.
                                </Nota>
                            </Cartao>
                        </Coluna>
                    </Col>
                </Row>
            </Container>
        </Secao>
    );
}
